import React from "react";
import { InteractiveContainer } from "../../primitives";

import { ReactComponent as CloseIcon } from "./assets/cancel.svg";

interface ItemsActionsFloatingBarProps {
  label: string;
  children: React.ReactNode;
  onClose: () => void;
}

export const ItemsActionsFloatingBar = ({
  onClose,
  label,
  children,
}: ItemsActionsFloatingBarProps) => (
  <>
    <div
      className="fixed bottom-10 left-1/2 z-10 ml-24 flex h-16 -translate-x-1/2 overflow-hidden rounded-xl bg-white drop-shadow-[0_8px_32px_rgba(0,0,0,0.16)]"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="font-regular flex items-center justify-center bg-primary-600 px-6 font-secondary text-sm text-white">
        {label}
      </div>

      {children}

      <InteractiveContainer
        className="flex w-20 items-center justify-center bg-grey-200 transition-colors hover:bg-grey-300"
        onClick={onClose}
      >
        <CloseIcon />
      </InteractiveContainer>
    </div>
  </>
);
